// frontend/client/src/components/ChatbaseErrorBoundary.js

import React, { Component } from 'react';
import { ChatbaseContext } from '../context/ChatbaseContext';

class ChatbaseErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // ✅ CORRECT: Use the Context object directly, not the hook
  static contextType = ChatbaseContext;

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("💥 CHATBASE CRITICAL FAILURE: React Error Boundary caught an error.", error, errorInfo);
    
    // ✅ Access context via this.context (class component pattern)
    if (this.context && typeof this.context.disableChatbase === 'function') {
      console.log('[Chatbase ErrorBoundary] Disabling Chatbase due to critical failure.');
      this.context.disableChatbase();
    }
  }

  render() {
    if (this.state.hasError) {
      // Return null to prevent broken UI from rendering
      return null;
    }
    return this.props.children;
  }
}

export default ChatbaseErrorBoundary;